// extracted by mini-css-extract-plugin
module.exports = {"error":"styles_error__1a8CV","root":"styles_root__2kI9O","wrapper":"styles_wrapper___wBai","refresh":"styles_refresh__SNhCR","icon":"styles_icon__afG7s"};